import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MD5 } from 'crypto-js';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService, PesquisaSatisfacaoService, StorageService } from '@app/services';

@Component({
  selector: 'app-solicitacao',
  templateUrl: './solicitacao.component.html',
  styleUrls: ['./solicitacao.component.scss']
})
export class SolicitacaoComponent implements OnInit {
  [x: string]: any;

  listaSolicitacoes: any;
  usuario: any;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private pesquisaSatisfacaoService: PesquisaSatisfacaoService,
    private serviceStorage: StorageService,
    private serviceGlobal: GlobalService,
  ) 
  { 
    this.usuario = this.serviceStorage.getAccess().usuario;
  }

  ngOnInit(): void {
    this.spinner.show();
    this.pesquisaSatisfacaoService
      .getSolicitacaoPorFiltro(1, this.usuario.matricula)
      .then((retorno:any)=>
      {
        if (!retorno.sucesso)
        {
          this.serviceGlobal.exibirAlerta(
            'warn',
            retorno.mensagem,
            null
          );
        }
        else
        {
          this.listaSolicitacoes = retorno.objeto;
        }
        this.spinner.hide();
      });
  }
  
  fechar(event) 
  {
    event.preventDefault();
    window.opener.focus();
    window.close();
  }

  abrirFormularioResposta(event: Event, idSolicitacao: number, tituloAtendimento: string, numeroAtendimento: string) {
    sessionStorage.setItem("idSol", (idSolicitacao + ""));
    this.router.navigateByUrl('/resposta?solicitacao=' + idSolicitacao);
  }

  getMD5(idSolicitacao, tituloAtendimento, numeroAtendimento){
    let retorno, concatenado, dataAtual;
    dataAtual = new Date();
    concatenado = idSolicitacao + tituloAtendimento + numeroAtendimento + dataAtual.getFullYear() + (dataAtual.getMonth() + 1) + dataAtual.getDate();
    retorno = MD5(concatenado);
    return retorno;
  }
}
